import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Alert, Button, Input, Label } from 'reactstrap'
import ConsignorSettlementsApiV2 from 'api/v2/admins/consignor-settlements-api-v2'

const SettlementConnectUser = ({ settlement, onConnected }) => {
  const [open, setOpen] = useState(false)
  const [query, setQuery] = useState('')
  const [users, setUsers] = useState([])
  const [userId, setUserId] = useState('')
  const [detailId, setDetailId] = useState('')
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const selectedUser = users.find((user) => String(user.id) === userId)
  const selectedDetail = selectedUser?.details.find((detail) => String(detail.id) === detailId)
  const message = (err) => err?.response?.data?.messages?.base || err?.response?.data?.message || err.message

  const search = async () => {
    if (busy || !query.trim()) return
    setBusy(true); setError(''); setUsers([]); setUserId(''); setDetailId('')
    try {
      const { data } = await ConsignorSettlementsApiV2.connectUserOptions(settlement.id, query.trim())
      setUsers(data.users || [])
      if (!(data.users || []).length) setError('User tidak ditemukan. Buat/lengkapi User di menu User List terlebih dahulu.')
    } catch (err) { setError(message(err)) }
    finally { setBusy(false) }
  }

  const connect = async () => {
    if (busy || !selectedUser || !selectedDetail || !reason.trim()) return
    if (!window.confirm(`Hubungkan ${settlement.sku} ke ${selectedDetail.name} (User #${selectedUser.id}, ${selectedUser.email})? Pastikan ini consignor/seller pemilik barang, bukan pembeli Deal. Rekening perlu dipilih ulang setelah terhubung.`)) return
    setBusy(true); setError('')
    let connected = false
    try {
      await ConsignorSettlementsApiV2.connectUser(settlement.id, { user_id: selectedUser.id, user_detail_id: selectedDetail.id, reason: reason.trim() })
      setOpen(false)
      connected = true
    } catch (err) { setError(message(err)) }
    finally { setBusy(false) }
    if (connected) onConnected()
  }

  return <Alert color='warning' className='mb-3'>
    <div>User consignor/seller belum terhubung. Hubungkan User yang benar agar email dan rekening bisa dipilih.</div>
    <Button type='button' color='primary' size='sm' className='mt-2' disabled={busy} onClick={() => setOpen(!open)}>{open ? 'Tutup Connect User' : 'Connect User'}</Button>
    {open && <div className='mt-3'>
      <Label>Cari User berdasarkan nama, email, atau ID</Label>
      <div className='d-flex mb-3'><Input value={query} disabled={busy} onChange={(event) => { setQuery(event.target.value); setUsers([]); setUserId(''); setDetailId('') }} onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); search() } }} /><Button type='button' className='ml-2' disabled={busy || !query.trim()} onClick={search}>Cari</Button></div>
      <Label>Pilih User consignor/seller</Label>
      <Input type='select' className='mb-3' value={userId} disabled={busy} onChange={(event) => { setUserId(event.target.value); setDetailId('') }}><option value=''>Pilih User</option>{users.map((user) => <option key={user.id} value={String(user.id)}>#{user.id} — {user.email} — {user.details.map((detail) => detail.name).filter(Boolean).join(' / ')}</option>)}</Input>
      <Label>Pilih User Detail yang sesuai</Label>
      <Input type='select' className='mb-3' value={detailId} disabled={busy || !selectedUser} onChange={(event) => setDetailId(event.target.value)}><option value=''>Pilih Detail</option>{(selectedUser?.details || []).map((detail) => <option key={detail.id} value={String(detail.id)}>{detail.name || '(nama kosong)'} — Detail #{detail.id}</option>)}</Input>
      <Label>Alasan menghubungkan User</Label>
      <Input type='textarea' maxLength={1000} className='mb-3' value={reason} disabled={busy} onChange={(event) => setReason(event.target.value)} />
      <small className='d-block mb-2'>Hanya untuk User yang belum terhubung sebelum proses Finance. Periksa nama dan email; hubungan yang sudah ada tidak diganti dari fitur ini. Setelah terhubung, buka User Detail untuk melengkapi rekening dan bukti chat.</small>
      <Button type='button' color='primary' disabled={busy || !selectedDetail || !reason.trim()} onClick={connect}>{busy ? 'Memproses...' : 'Hubungkan User'}</Button>
    </div>}
    {error && <div className='text-danger mt-2' style={{whiteSpace: 'pre-line'}}>{error}</div>}
  </Alert>
}
SettlementConnectUser.propTypes = { settlement: PropTypes.object.isRequired, onConnected: PropTypes.func.isRequired }
export default SettlementConnectUser
